export default [
  {
    title: 'ตรวจสอบราศี',
    icon: 'ImageIcon',
    route: 'zodiac-management',
    action: 'all',
    resource: 'admin',
  },
]
